import type { PasswordConfig } from '@/types/passwordConfig';

interface PasswordRequirementsGuideProps {
  config?: PasswordConfig | null;
  requirements: string[];
}

export default function PasswordRequirementsGuide({
  config,
  requirements,
}: PasswordRequirementsGuideProps) {
  if (!requirements.length) {
    return null;
  }

  return (
    <div className="text-xs text-gray-600 mt-1">
      {config?.description && (
        <div className="font-medium mb-1">{config.description}</div>
      )}
      <ul className="list-disc ps-4 space-y-0.5">
        {requirements.map((requirement) => (
          <li key={requirement}>{requirement}</li>
        ))}
      </ul>
    </div>
  );
}
